import React, { useEffect, useRef, useState, useCallback } from 'react';
import { Send } from 'lucide-react';
import api from './api';

const fmt = (iso) => { try { return new Date(iso).toLocaleString('en-GB', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' }); } catch { return ''; } };

const Chat = ({ jobId }) => {
  const [data, setData] = useState({ messages: [], canMessage: false });
  const [text, setText] = useState('');
  const [sending, setSending] = useState(false);
  const endRef = useRef(null);
  const myId = data.myId;

  const load = useCallback(() => {
    api.get(`/jobs/${jobId}/messages`).then((r) => setData(r.data)).catch(() => {});
  }, [jobId]);

  useEffect(() => {
    load();
    const t = setInterval(load, 4000);
    return () => clearInterval(t);
  }, [load]);

  useEffect(() => { if (endRef.current) endRef.current.scrollIntoView({ behavior: 'smooth' }); }, [data.messages.length]);

  const send = async (e) => {
    e.preventDefault();
    const t = text.trim(); if (!t) return;
    setSending(true);
    try { await api.post(`/jobs/${jobId}/messages`, { text: t }); setText(''); load(); }
    catch (err) {} finally { setSending(false); }
  };

  if (!data.canMessage) return null;

  return (
    <div className="mt-6 rounded-2xl bg-white p-6 shadow-sm" data-testid="chat-panel">
      <h2 className="font-display text-lg font-bold text-[#1b4f72]">Messages {data.otherPartyName ? `with ${data.otherPartyName}` : ''}</h2>
      <div className="mt-4 max-h-80 space-y-2 overflow-y-auto rounded-xl bg-[#f4f8f5] p-4" data-testid="chat-messages">
        {data.messages.length === 0 ? <p className="py-6 text-center text-sm text-gray-400">No messages yet. Say hello 👋</p> : data.messages.map((m) => {
          const mine = m.senderId === myId;
          return (
            <div key={m.id} className={`flex ${mine ? 'justify-end' : 'justify-start'}`}>
              <div className={`max-w-[75%] break-words rounded-2xl px-4 py-2 text-sm ${mine ? 'bg-[#3a9b5c] text-white' : 'bg-white text-gray-700 shadow-sm'}`}>
                <p>{m.text}</p>
                <p className={`mt-1 text-[10px] ${mine ? 'text-white/70' : 'text-gray-400'}`}>{m.senderName} · {fmt(m.createdAt)}</p>
              </div>
            </div>
          );
        })}
        <div ref={endRef} />
      </div>
      <form onSubmit={send} className="mt-4 flex gap-2">
        <input data-testid="chat-input" value={text} onChange={(e) => setText(e.target.value)} placeholder="Type a message…" className="min-w-0 flex-1 rounded-full border border-gray-300 px-4 py-2.5 text-sm outline-none focus:border-[#3a9b5c]" />
        <button data-testid="chat-send-btn" disabled={sending || !text.trim()} className="flex shrink-0 items-center gap-1.5 rounded-full bg-[#3a9b5c] px-5 py-2.5 text-sm font-semibold text-white hover:bg-[#318150] disabled:opacity-50"><Send size={15} /> Send</button>
      </form>
    </div>
  );
};

export default Chat;
